import { Handle, Position } from 'reactflow';
import { Tags } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo } from './node-chrome';
import { SaidaNomeada } from './node-saida';

export default function AIClassifierNode({ data }: any) {
  const categorias: string[] = (Array.isArray(data.categories) ? data.categories : [])
    .map((c: string) => String(c).trim())
    .filter(Boolean);

  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="ai_classifier"
        dados={data}
        icone={Tags}
        corDoTopo="bg-cyan-500"
        corDoIcone="text-cyan-600"
        titulo={data.label || 'Separar por assunto'}
        largura="w-[240px]"
      >
        {categorias.length > 0 && (
          <div className="mt-2 border-t border-border/40 pt-1.5">
            {categorias.map((cat) => (
              // O id da saída é a categoria em minúsculas — é assim que o motor
              // casa a classificação com a aresta. Não normalizar de outro jeito.
              <SaidaNomeada key={cat} id={cat.toLowerCase()} rotulo={cat} cor="neutro" />
            ))}
          </div>
        )}
      </CartaoDoNo>
      {categorias.length === 0 && (
        <Handle type="source" position={Position.Right} className="!w-2.5 !h-2.5 !bg-gray-300 !border-gray-400" />
      )}
    </>
  );
}
